import { render, staticRenderFns } from "./MigrateToGit.vue?vue&type=template&id=3787a5ec&"
import script from "./MigrateToGit.vue?vue&type=script&lang=js&"
export * from "./MigrateToGit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports